import Paragraph from "./Paragraph";
import { BackgroundContainer, Container, Heading, Content, Title, Counter } from "./styles";
import { padStart } from "lodash";
import { useEffect, useRef, useState } from "react";
import gsap, { ScrollTrigger } from "@/lib/gsap";

type Props = {
  title?: string;
  paragraphs?: { _key: string; title: string; body: string }[];
};

const formatCounterValue = (total: number) =>
  padStart(total.toString(), 2, "0");

/**
 *
 * @param props
 * @returns
 *
 * @see https://www.figma.com/file/16YSFRr06xdFYJFqNgvv41/Bormioli-Product-Design?node-id=395%3A35853
 */
const NumberedParagraphs: React.FC<Props> = (props) => {
  const { title, paragraphs } = props;
  const [timeline] = useState(() =>
    gsap.timeline({ defaults: { duration: 0.3 } })
  );

  const containerRef = useRef<HTMLDivElement>(null);
  const counterValueRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    // Create closure around mutable refs
    const container = containerRef.current;

    if (container) {
      timeline.to(container, {
        opacity: 1.0,
        y: 0,
      });
    }

    ScrollTrigger.create({
      trigger: container,
      toggleActions: "play pause resume reverse",
      start: "top 75%",
      animation: timeline,
    });

    return () => {
      timeline.kill();
    };
  }, [timeline]);

  return (
    <BackgroundContainer ref={containerRef}>
      <Container>
        <Heading>
          <Title as="h2">{title}</Title>
          {paragraphs && (
            <Counter>
              <span ref={counterValueRef}>{formatCounterValue(1)}</span>
              <span>{formatCounterValue(paragraphs.length)}</span>
            </Counter>
          )}
        </Heading>
        {paragraphs && (
          <Content>
            {paragraphs.map((paragraph, index) => (
              <Paragraph
                timeline={timeline}
                count={formatCounterValue(index + 1)}
                key={paragraph._key}
                title={paragraph.title}
                counterValueRef={counterValueRef}
              >
                {paragraph.body}
              </Paragraph>
            ))}
          </Content>
        )}{" "}
      </Container>
    </BackgroundContainer>
  );
};

export default NumberedParagraphs;
